import styles from "../../../styles/Components/bot/bot-overview/BotOverall.module.css";
import { useSelector } from "react-redux";
import BotPerformanceChart from "../../../shared/BotPerformanceChart";
import BotOverallPerformance from "../../new-dashboard/bot-performance/BotOverallPerformance";

function BotOverall() {
  const {
    dashboard: {
      botInfoStatus,
      overallBotPerformance: {
        overall_performance: {
          balance_date_list: balanceDates,
          balance_lists: balanceLists,
        } = {},
        status,
      },
    },
  } = useSelector((state) => state);

  if (botInfoStatus !== "success" || !balanceLists?.length) return null;

  return (
    <div className={styles.container}>
      {status === "ok" && (
        <BotPerformanceChart
          balanceLists={balanceLists}
          balanceDateList={balanceDates}
        />
      )}
      <BotOverallPerformance />
    </div>
  );
}

export default BotOverall;
